window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fNav = require('./components/nav')
const fSmoothScroll = require('./utils/smooth-scroll')
const fToggleSection = require('./components/toggle-section')
const fCarousel = require('./components/carousels')
const fCLogo = require('./components/c-logo')
const fPopup = require('./components/popup')
const fGsapController = require('./components/gsap-controller')

// Vue Support Function
import {
    createApp,
    defineAsyncComponent
} from 'vue'

const InitVueComponents = () => {
    // Static Components
    // const StaticComponents = require('./vue/multi-file-component/child-component').default;

    // Init Vue Instance
    
    // Load More Rows
    if ( document.getElementById("vue-space-load-more-rows") ) {
        const LoadMoreRows = defineAsyncComponent(() => import("./vue/load-more-rows"));
        const $VueApp = createApp({});
        $VueApp
            .component("load-more-rows", LoadMoreRows);

        $VueApp.mount('#vue-space-load-more-rows');
    }

    // Chart Pie
    if ( document.getElementById("vue-space-chart-pie") ) {
        const ChartPie = defineAsyncComponent(() => import("./vue/chart-pie"));
        const $VueApp = createApp({});
        $VueApp
            .component("chart-pie", ChartPie);

        $VueApp.mount('#vue-space-chart-pie');
    }

    // Footer Popup
    if ( document.getElementById("vue-space-footer-popup") ) {
        const FooterPopup = defineAsyncComponent(() => import("./vue/footer-popup"));
        const $VueApp = createApp({});
        $VueApp
            .component("footer-popup", FooterPopup);
            

        $VueApp.mount('#vue-space-footer-popup');
    }

    // Team List
    if ( document.getElementById("vue-space-team-list") ) {
        const TeamList = defineAsyncComponent(() => import("./vue/team-list"));
        const $VueApp = createApp({});
        $VueApp
            .component("team-list", TeamList);


        $VueApp.mount('#vue-space-team-list');
    }

    // Featured Property
    if ( document.getElementById("vue-space-featured-property") ) {
        const FeaturedPropertyPosts = defineAsyncComponent(() => import("./vue/featured-property-posts"));
        const $VueApp = createApp({});
        $VueApp
            .component("featured-property-posts", FeaturedPropertyPosts);
        
        $VueApp.mount('#vue-space-featured-property');
    }

    // Portfolio filter
    if ( document.getElementById("vue-space-portfolio-filter") ) {
        const PortfolioFilter = defineAsyncComponent(() => import("./vue/portfolio-filter"));
        const $VueApp = createApp({});
        $VueApp
            .component("portfolio-filter", PortfolioFilter);
        
        $VueApp.mount('#vue-space-portfolio-filter');
    }
}

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    fSmoothScroll()
    fNav()
    fToggleSection()
    fCLogo()
    fPopup()
    fGsapController.init()
    fCarousel.init()
    
    if ( 
        document.getElementById("vue-space-load-more-rows") ||
        document.getElementById("vue-space-chart-pie") ||
        document.getElementById("vue-space-footer-popup") ||
        document.getElementById("vue-space-featured-property") ||
        document.getElementById("vue-space-portfolio-filter")
    ) {
        InitVueComponents()
    }
})
